import React, { Component } from 'react';
import './index.scss';
import { Row, Col, Button, DatePicker, message, Spin, Input } from 'antd';
import dataDefault from './data';
import imgSave from "../saveImg";
import moment from 'moment';
import Auth from "../Auth";
import Compared from "../Compared";
import request from '@/method/axios';

const { MonthPicker } = DatePicker;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    getDateData = async (date) => {
        try {
            const dataBegin = JSON.stringify(dataDefault);
            let data = JSON.parse(dataBegin);
            const x = await request.get(`/api/cover?year=${moment(date).format('YYYY')}`);
            if (x.data && x.data.length > 0) {
                if (x.data.length != 16 && moment(date).format('YYYY') >= 2019) {
                    data = data.map((item, i) => {
                        return {
                            ...x.data[i],
                            ...item
                        }
                    });
                } else {
                    data = x.data;
                }
            }

            this.setState({ loading: false, data });
        } catch (error) {
            this.setState({ loading: false });
        }
    }



    onSave = async () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let data = this.state.data.map(x => ({ ...x, year }));
        const res = await request.post('/api/coverSave', {
            data,
            year
        });
        this.setState({ loadingSave: false });
        if (res.code == 200) {
            message.success('保存成功！');
            if (data[0] && !data[0].id) {
                this.getDateData(this.state.date);
            }
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table10', 1.5, '0.00', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        return (
            <Spin spinning={this.state.loading}>
                <div className="table_cover table7_1_1">
                    <div id='table10' style={{ paddingBottom: 10 }}>

                        <Row className="title">Hotel Information 酒店信息</Row>
                        <Row className="cover_month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY")}
                                format="YYYY"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        loading: true,
                                        data: []
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Row className="content">
                            <Row className="row">
                                <Col span={6} className="col_border col_border_input">名称</Col>
                                <Col span={6} className="col_border col_border_input">内容</Col>
                                <Col span={6} className="col_border col_border_input">电话</Col>
                                <Col span={6} className="col_border col_border_input">邮箱</Col>
                            </Row>

                            {this.state.data.map((x, i) => {
                                const _reTimeReg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/;
                                return (
                                    <Row className="row" key={i}>
                                        <Col span={6} className="col_border">{x.name}</Col>
                                        <Col span={6} className="col_border col_border_input">
                                            <Compared
                                                data={{ index: i, key: 'value', title: "", sqlName: "_cover", name: x.name, type: 'text' }}
                                            >
                                                {i === 4 ?
                                                    <DatePicker
                                                        value={_reTimeReg.test(x.value) ? moment(x.value, 'YYYY-MM-DD') : moment(new Date(), 'YYYY-MM-DD')}
                                                        placeholder="请选择时间！"
                                                        style={{ width: "100%" }}
                                                        onChange={(date, str) => {
                                                            let data = this.state.data;
                                                            data[i].value = str;
                                                            this.setState({
                                                                data
                                                            });
                                                        }}
                                                    />
                                                    :

                                                    <Input
                                                        value={x.value}
                                                        placeholder="请输入！"
                                                        onChange={(e) => {
                                                            let value = e.target.value || "";
                                                            let data = this.state.data;
                                                            data[i].value = value;
                                                            this.setState({ data });
                                                        }}
                                                    />

                                                }
                                            </Compared>
                                        </Col>
                                        <Col span={6} className="col_border col_border_input">
                                            {
                                                i > 4 && <Compared
                                                    data={{ index: i, key: 'tel', title: "", sqlName: "_cover", name: x.name, type: 'text' }}
                                                >
                                                    <Input
                                                        value={x.tel}
                                                        placeholder="请输入电话！"
                                                        onChange={(e) => {
                                                            let value = e.target.value || "";
                                                            let data = this.state.data;
                                                            data[i].tel = value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </Compared>
                                            }

                                        </Col>
                                        <Col span={6} className="col_border col_border_input">
                                            {i > 4 && <Compared
                                                data={{ index: i, key: 'email', title: "", sqlName: "_cover", name: x.name, type: 'text' }}
                                            >
                                                <Input
                                                    value={x.email}
                                                    placeholder="请输入邮箱！"
                                                    onChange={(e) => {
                                                        let value = e.target.value || "";
                                                        let data = this.state.data;
                                                        data[i].email = value;
                                                        this.setState({ data });
                                                    }}
                                                />
                                            </Compared>}
                                        </Col>
                                    </Row>
                                )
                            })}

                        </Row>
                    </div>
                    <Auth loading={this.state.loading} auth="edit_cover">
                        <Row className="table-footer-btn" style={{ paddingRight: 24 }}>
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/cover/index.js